/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Integration_Limit_2_ValueInputs */

const en_svc_integration_limit_2_value = /** @type {(inputs: Svc_Integration_Limit_2_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We work with your current software rather than replacing it.`)
};

const lv_svc_integration_limit_2_value = /** @type {(inputs: Svc_Integration_Limit_2_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strādājam ar Jūsu esošo programmatūru, nevis to aizstājam.`)
};

/**
* | output |
* | --- |
* | "We work with your current software rather than replacing it." |
*
* @param {Svc_Integration_Limit_2_ValueInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_integration_limit_2_value = /** @type {((inputs?: Svc_Integration_Limit_2_ValueInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Integration_Limit_2_ValueInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_integration_limit_2_value(inputs)
	return en_svc_integration_limit_2_value(inputs)
});